module.exports = __webpack_public_path__ + "static/media/paginacao.7766999f.png";